import "./public-path";
import Vue from 'vue';
import vuetify from './plugins/vuetify';
import store from './store/store.js'
import VCalendar from 'v-calendar';
import Info from './components/Info.vue';
import DateLocation from "./components/DateLocation/DateLocation.vue";
import Stepper from "./components/Stepper/Stepper.vue";
import BottomToolbar from "./components/BottomToolbar.vue";
import CategoryDrawer from "./components/CategoryDrawer.vue";
import ReplaceScreen from "./components/ReplaceScreen.vue";
import Snackbar from "./components/Snackbar.vue";

import {getGiftBoxes, getGifts, getBabAddons, getBab, getCollection, getBabTypes} from './api/products'
import {getTimeSlots} from '../common/api/static'
import { TYPE_SET_ADDONS, TYPE_SET_GIFTS, TYPE_SET_GIFT_BOXES, TYPE_SET_GIFT_CARDS, TYPE_SET_PRODUCT_DETAILS, TYPE_SET_CATEGORIES, TYPE_SET_CUSTOMER_HASH, TYPE_SET_CUSTOMER_ID, TYPE_SET_TIMESLOTS } from "./store/mutations";
// Vue.config.devtools = false
Vue.use(VCalendar);
Vue.component('hb-bab-info',Info);
Vue.component('hb-bab-datelocation', DateLocation);
Vue.component('hb-bab-stepper', Stepper);
Vue.component('hb-bab-bottom-toolbar', BottomToolbar);
Vue.component('hb-bab-category-drawer', CategoryDrawer);
Vue.component('hb-bab-replace-screen', ReplaceScreen);
Vue.component('hb-bab-snackbar',Snackbar);

const datePicker = new Vue({
    el: '#hb-build-a-box',
    vuetify,
    store,
    created(){
        const container = document.querySelector('.product-detail-layout > .container');

        container.style.paddingRight = 0;
        container.style.paddingLeft = 0;
    },
    async mounted(){
        this.$store.commit(TYPE_SET_TIMESLOTS, await getTimeSlots({
            time_slot_name: 'mothers_day',
            auto_swap: 'true'
        }));
        console.log()
        const giftBoxes = await getGiftBoxes()
        this.$store.commit(TYPE_SET_GIFT_BOXES, giftBoxes);
        
        this.$store.commit(TYPE_SET_CATEGORIES, await getBabTypes());
        this.$store.commit(TYPE_SET_GIFTS, await getGifts());

        this.$store.commit(TYPE_SET_ADDONS, await getBabAddons());

        const giftCards = await getCollection({
            include_products:true,
            collection_handler:'greeting-cards'
        })
        this.$store.commit(TYPE_SET_GIFT_CARDS, giftCards);
        this.$store.commit(TYPE_SET_CUSTOMER_ID, this.$root.$el.dataset.customerId);
        this.$store.commit(TYPE_SET_CUSTOMER_HASH, this.$root.$el.dataset.hash);
    }
})